export default __webpack_public_path__ + "static/media/bitNerdy.790d426e.jpg";